import useShared from "../../../../../shared/_common/_shared";

export default function MinosEmptyData(props) {
    const {title} = props;
    const {IconCommon} = useShared();

    return (
        <IconCommon
            isAlwaysInActive
            iconName={"cm-empty-regular"}
            className={"empty-data"}
            title={title || "noData"}
        />
    );
}
